<template>
  <div class="welfareSearchResult">
    <!-- logo 搜索 company-->
    <search-com
      :searchValStr="search.value"
      @search-btn="searchBtn"
    ></search-com>
    <div class="nav_box">
      <welfare-breadcrumb :itemBreadcrumb="itemBreadcrumb"></welfare-breadcrumb>
    </div>
    <div class="search_type">
      <span :style="search.type==1?'color:#4c80fa;':''" @click="changeType(1)">按相关度</span>
      <i style="font-style:normal;">|</i>
      <span :style="search.type==2?'color:#4c80fa;':''" @click="changeType(2)">按时间</span>
    </div>
    <!-- 搜索结果列表 -->
    <div class="GoodListCom" v-if="goodAndMealList.length > 0" style="margin-top:20px;">
      <div class="searchResult_box">
        <div
          @click="goDetails(item)"
          v-for="item in goodAndMealList"
          :key="item.id"
          class="item_box"
        >
          <el-image
            v-if="item.mealUrl"
            style="width: 258px; height: 258px"
            :src="item.mealUrl"
            fit="fill"
          >
          </el-image>
          <div class="goodName">
            {{ item.mealName }}
          </div>
          <div class="price_box">
            <template v-if="item.mealPrice">
              <span style="font-size: 14px;">￥</span>
              <span class="price">{{ item.mealPrice }}</span>
            </template>
          </div>
          <div class="viewDetail">查看详情</div>
        </div>
      </div>
      <div class="pagination_box">
        <!-- 分页 -->
        <el-pagination
          v-if="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageIndex"
          :page-sizes="pagination.pageArray"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <section class="con-body" v-else>
      <div class="shopping_car_empty">
        <img class="img" src="~/assets/img/welfareMall/search_bg.png" alt="" />
        <div></div>
      </div>
    </section>
  </div>
</template>

<script>
import SearchCom from "@/components/welfareMallComp/SearchCom";
import WelfareBreadcrumb from "@/components/welfareMallComp/WelfareBreadcrumb";
import { getReqGoodAndMealList } from "@/network/welfareMall_api";
export default {
  components: { SearchCom, WelfareBreadcrumb },
  name: "WelfareSearchResult",
  data() {
    return {
      itemBreadcrumb: [
        {
          name: "企业商城",
          to: "/welfareHome",
        },
        {
          name: "搜索结果",
        },
      ],
      search:{
        value:'',
        type:1,
      },
      pagination: {
        pageIndex: 1,
        limit: 20,
        total: 0,
        pageArray:[5,10,20,50]
      },
      goodAndMealList: [],
    };
  },
  computed: {},
  watch: {
    //监听参数变化
    $route: {
      handler() {
        //console.log(this.$route.params.value)
        if (this.$route.params.value) {
          this.search.value = this.$route.params.value;
          this.getGoodAndMealList(this.search.value);
        }
      },
    },
  },
  created() {
    if (this.$route.params.value) {
      this.search.value = this.$route.params.value;
      this.getGoodAndMealList(this.search.value);
    }
  },
  methods: {
    // 点击搜索
    searchBtn(val) {
      // val 是从搜索组件中传递过来
      this.pagination.pageIndex = 1;
      this.pagination.limit = 20;
      this.search.value = val;
      this.getGoodAndMealList();
    },
    changeType(type){
      this.pagination.pageIndex = 1;
      this.pagination.limit = 20;
      this.search.type=type;
      this.getGoodAndMealList()
    },
    // 获取搜索到的商品或礼包列表
    async getGoodAndMealList() {
      const { pageIndex, limit } = this.pagination;
      if(!this.search.value) return;
      let res = await getReqGoodAndMealList({
        name: this.search.value,
        orderType:this.search.type,
        pageIndex,
        limit,
      });
      if (res.isSuccess) {
        let goodAndMealList = res.data;
        // 过滤图片 显示第一张
        goodAndMealList.forEach((item) => {
          item.mealUrl = item.mealUrl.split(";")[0];
        });
        this.goodAndMealList = goodAndMealList;
        this.pagination.total = res.count;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 页面条数发生改变
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.pageIndex = 1;
      this.getGoodAndMealList();
    },
    //页面页码发生改变
    handleCurrentChange(val) {
      this.pagination.pageIndex = val;
      this.getGoodAndMealList();
    },
    //   跳转详情
    goDetails(info) {
      const { mealID, mealType, type, isActive } = info;
      // 节日福利套餐  Type=0，MealType=1 跳转礼包详情页
      // 节日福利集采  Type=1，MealType=1 跳转商品详情页
      // 员工体检套餐 Type=1，MealType=2 跳转体检套餐详情页
      // 员工体检机构  Type=1，MealType=3 跳转体检机构详情页
      // 员工学习课程 Type = 2，MealType为赋值，默认0 跳转员工学习课程详情页
      //缓存当前ID 刷新用到
      if (type == 0) {
        sessionStorage.setItem("welfareMall_mealId", mealID);
        // 判断该礼包是否有效
        sessionStorage.setItem("welfareMall_isActive", isActive);
        // sessionStorage.setItem('vueRouter', JSON.stringify('/welfareSetMealDetails'));
        document.cookie = "vueRouter=" + "/WelfareSetMealDetails";
        this.$router.push({
          name: "WelfareSetMealDetails",
          params: { mealID },
        });
      } else if (type == 1) {
        if (mealType == 1) {
          sessionStorage.setItem("welfareMall_goodId", mealID);
          // sessionStorage.setItem('vueRouter', JSON.stringify('/welfareProductDetails'));
          document.cookie = "vueRouter=" + "/productDetails";
          this.$router.push({
            name: "productDetails",
            query: { id:mealID },
          });
        } else if (mealType == 2) {
          sessionStorage.setItem("welfareMall_mealId", mealID);
          sessionStorage.setItem("welfareMall_isActive", isActive);
          document.cookie = "vueRouter=" + "/TijianMealDetails";
          this.$router.push({
            name: "TijianMealDetails",
            query: { mealId: mealID },
          });
        } else if (mealType == 3) {
          sessionStorage.setItem("welfareMall_mealId", mealID);
          sessionStorage.setItem("welfareMall_isActive", isActive);
          document.cookie = "vueRouter=" + "/OrganizationDetails";
          this.$router.push({
            name: "OrganizationDetails",
            query: { hospId: mealID },
          });
        }
      } else if (type == 2) {
        sessionStorage.setItem("welfareMall_goodId", mealID);
        // sessionStorage.setItem('vueRouter', JSON.stringify('/welfareProductDetails'));
        document.cookie = "vueRouter=" + "/learningDetails";
        this.$router.push({
          name: "learningDetails",
          query: { courseId: mealID },
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.welfareSearchResult {
  .search_type{
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    margin-top: -20px;
    span{
      font-size: 14px;
      margin: 0 5px;
      cursor: pointer;
    }
  }
  .searchResult_box{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    &:nth-child(2){
      .goodName{
        height: auto !important;
      }
    }
    .item_box{
      width: 282px;
      height: 369px;
      border: 1px solid #E0E0E0;
      margin: 0 24px 24px 0;
      padding: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      position: relative;
      .goodName{
        display:-webkit-box;
        font-size: 14px;
        line-height: 24px;
        height: 43px;
        text-overflow: ellipsis;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        overflow:hidden;
      }
      .araeName{
        margin:5px 0;
        display: flex;
        justify-content:space-between;
        span:nth-child(1){
          width: 190px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis
        }
      }
      .price_box{
        color: #F5222D;
        .price{
          font-size: 18px;
          font-weight: 600;
        }
      }
      .viewDetail{
        position: absolute;
        right: 12px;
        bottom: 12px;
        color: #0089cd;
        font-size: 14px;
      }

    }
    .item_box:nth-child(4n){
      margin-right: 0;
    }
    .item_box:hover{
        border: 1px solid #F5222D;
    }
  }
  .pagination_box{
    width: 1200px;
    margin: 20px auto;
    text-align: right;
  }

  .shopping_car_empty {
    height: 600px;
    display: flex;
    justify-content: center;
    .img {
      width: 450px;
      height: 450px;
    }
  }
}
</style>
